<template>
    <div class="notice-container">
        <div class="notice-header">
            <div :class="{active:activeCode === '1'}" @click="activeCode='1'">
                <span class="notice-header-title">招标公告</span>
                <span class="notice-header-badge" v-if="noticeData.totalCount ">{{ noticeData.totalCount }}</span>
            </div>
            <div :class="{active:activeCode === '2'}" @click="activeCode='2'">
                <span class="notice-header-title">项目公告</span>
                <span class="notice-header-badge" v-if="noticeData.projectTotalCount ">{{ noticeData.projectTotalCount }}</span>
            </div>
        </div>
        <div class="notice-content" :style="maxHeight">
            <!-- 招标公告列表 -->
            <template v-if="activeCode === '1'">
                <div
                    v-for="item in noticeData.childList"
                    :key="item.id"
                    class="notice-content-item bigData-btn-detail-notice"
                    :class="{ 'notice-content-read': item.readFlag }"
                    @click="onViewNotice(item)"
                >
                    <div class="notice-content-item-top">
                        <span class="notice-content-item-lable">{{
                            item.noticeTitle
                        }}</span>
                        <span
                            class="notice-content-item-tag"
                            :class="{ 'hot-tag': item.recommendFlag }"
                            >{{ item.recommendFlag ? "推荐" : "" }}</span
                        >
                    </div>
                    <div class="notice-content-item-bottom">
                        {{ item.createTime }}
                    </div>
                </div>
                <div
                    v-if="!noticeData.childList.length"
                    class="notice-content-empty"
                >
                    <div class="notice-content-empty-content">
                        <i class="notice-content-empty-img"></i>
                        <span class="notice-content-empty-text"
                            >暂无相关的招标公告</span
                        >
                    </div>
                </div>
            </template>
            <!-- 项目公告列表 -->
            <template v-if="activeCode === '2'">
                <div
                    v-for="item in noticeData.projectList"
                    :key="item.id"
                    class="notice-content-item bigData-btn-detail-notice"
                    :class="{ 'notice-content-read': item.readFlag }"
                    @click="onViewNotice(item)"
                >
                    <div class="notice-content-item-top">
                        <span class="notice-content-item-lable">{{
                            item.noticeTitle
                        }}</span>
                    </div>
                    <div class="notice-content-item-bottom">
                        {{ item.createTime }}
                    </div>
                </div>
                <div
                    v-if="!noticeData.projectList.length"
                    class="notice-content-empty"
                >
                    <div class="notice-content-empty-content">
                        <i class="notice-content-empty-img"></i>
                        <span class="notice-content-empty-text"
                            >暂无相关的项目公告</span
                        >
                    </div>
                </div>
            </template>
        </div>
        <div class="notice-btn bigData-btn-all-notice" @click="onAllNotice">
            <div class="notice-btn-inner">
                <span class="notice-btn-icon"></span>
                <span class="notice-btn-text">全部公告</span>
            </div>
        </div>
        <div class="notice-footer" v-if="isConfig">
            <i
                class="notice-footer-btn delete-icon"
                @click="onNoticeDelete(noticeData)"
            ></i>
            <i class="notice-footer-btn move-icon"></i>
        </div>
    </div>
</template>
<script>
import { addBidNoticeReadLog } from '../manageDaskApi';
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['supplier'])
    },
    props: {
        noticeData: {
            type: Object,
            default() {
                return {
                    code: 'notice',
                    isRemove: false,
                    totalCount: 0,
                    childList: [],
                    projectTotalCount: 0,
                    projectList: []
                };
            }
        },
        maxHeight: {
            type: String,
            default() {
                return 'max-height: 494px;height:494px;';
            }
        },
        isConfig: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            activeCode: '1'
        };
    },
    mounted() {},
    components: {},
    methods: {
        onNoticeDelete(params) {
            this.$emit('on-delete', params);
        },
        onViewNotice(params) {
            const pageParams = {
                path: '/lsrm/supPreviewNotice',
                query: { id: params.id }
            };
            setTimeout(() => {
                this.linkToPointPage(pageParams);
                this.getAddBidNoticeReadLog(params);
            }, 0);
        },
        getAddBidNoticeReadLog(params) {
            const readPramas = {
                noticeCode: params.noticeCode,
                supplierCode: this.supplier.supplierCode
            };
            if (params.readFlag) {
                return;
            }
            addBidNoticeReadLog(readPramas)
                .then(res => {})
                .finally(() => {
                    // this.noticeData.childList = dataList;
                });
        },
        onAllNotice() {
            this.$emit('on-all-detail');
        },
        linkToPointPage(page) {
            setTimeout(() => {
                this.$router.push({
                    path: page.path,
                    query: page.query
                });
            }, 0);
        }
    }
};
</script>
<style lang="less" scoped>
.notice {
    &-container {
        // width: 280px;
        // height: 592px;
        background: #ffffff;
        border-radius: 4px;
        padding: 24px 0 24px 12px;
        // border: 1px solid red;
    }
    &-header {
        width: 100%;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        > div{
            padding: 0 12px;
            width: 50%;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            &.active{
                .notice-header-title{
                    color: #398cff;
                }
            }
        }
        &-title {
            height: 24px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #1d2129;
            line-height: 24px;
            transition: all 0.25s linear;
        }
        &-badge {
            display: inline-block;
            padding: 0 5px;
            background: #f44837;
            border-radius: 2px 2px 2px 0px;
            text-align: center;
            height: 18px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 18px;
            margin-left: 8px;
        }
    }
    &-content {
        margin-top: 24px;
        max-height: 496px;
        // padding-left: 12px;
        overflow-x: hidden;
        overflow-y: auto;
        .notice-content {
            &-empty {
                display: flex;
                // flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                text-align: center;
                color: #898c8c;
            }
            &-empty-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            &-empty-img {
                display: inline-block;
                // margin-right: 5px;
                width: 110px;
                height: 80px;
                background: url(../img/noData.png) no-repeat;
                background-size: 100%;
            }
            &-empty-text {
                height: 22px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #4e5969;
                line-height: 22px;
            }
        }
        &-item {
            display: inline-block;
            width: calc(100% - 24px);
            font-family: PingFangSC-Regular, PingFang SC;
            cursor: pointer;
            padding: 4px 12px 4px 12px;
            margin-bottom: 4px;
            background-color: #ffffff;
            &:link {
                text-decoration: none;
                background: #ffffff;
                .notice-content-item-lable {
                    color: #1d2129;
                }
            }
            &.notice-content-read {
                background: #ffffff;
                .notice-content-item-lable {
                    color: #86909c;
                }
            }

            &:hover {
                background: #f2f3f5;
                .notice-content-item-lable {
                    color: #1d2129;
                }

                &.notice-content-read {
                    .notice-content-item-lable {
                        color: #86909c;
                    }
                }
            }
            &:last-child {
                margin-bottom: 0;
            }
            &-top {
                display: flex;
                margin-bottom: 4px;
            }
            &-bottom {
                // width: 117px;
                height: 20px;
                font-size: 12px;

                font-weight: 400;
                color: #86909c;
                line-height: 20px;
            }
            &-lable {
                display: inline-block;
                width: 85%;
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: #1d2129;
                line-height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            &-tag {
                display: inline-block;
                width: 40px;
                height: 20px;
                border-radius: 2px;
                text-align: center;
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                line-height: 20px;
                margin-left: 16px;
                &.hot-tag {
                    background: #f44837;
                }
            }
        }
    }
    &-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 15px);
        height: 32px;
        background: #ffffff;
        border-radius: 3px;
        border: 1px solid #e5e6eb;
        margin-top: 16px;
        cursor: pointer;
        &:hover {
            background: #f2f3f5;
        }
        &:active {
            background: #e5e6eb;
        }
        &-inner {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 73px;
            height: 22px;
        }
        &-icon {
            display: inline-block;
            margin-right: 5px;
            width: 12px;
            height: 12px;
            background: url(../img/btn-all@2x.png) no-repeat;
            background-size: 100%;
            // background-position: -14px -6px;
        }
        &-text {
            display: inline-block;
            width: 56px;
            height: 22px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1d2129;
            line-height: 22px;
        }
    }
    &-footer {
        display: flex;
        justify-content: flex-end;
        background-color: #ffffff;
        margin-top: 62px;
        // border: 1px solid blue;
        &-btn {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 22px;
            &:last-child {
                margin-right: 0;
            }

            &:hover {
                opacity: 0.9;
            }
            &:active {
                opacity: 0.6;
            }
        }
        .delete-icon {
            background: url(../img/delete.png) no-repeat;
            background-size: 100%;
            cursor: pointer;
        }
        .move-icon {
            background: url(../img/move-outline.png) no-repeat;
        }
    }
}
</style>
